// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-mic {
  width: 14px !important;
  height: auto;
  margin-right: 10px;
  margin-left: 20px;
}

.textarea {
  flex: 1 1; /* Take remaining space */
  border: none; /* Remove default textarea border */
  resize: none; /* Disable textarea resizing */
  font-size: 14px; /* Example font size */
  padding: 10px; /* Example padding */
  outline: none;
}

.send-button {
  width: 7%;
  height: 30px;
  margin: 7px 20px 0 15px;
  cursor: pointer;
  background-color: rgb(161, 0, 255);
  border-radius: 20px;
}

.mid-section {
  background-color: white;
  height: 45px;
  width: 50%;
  border-radius: 18px;
  border: 1px solid white;
  margin: 20px auto 0; /* shorthand for margin: top auto 0; */
  display: flex;
  flex-direction: row;
  justify-content: center; /* horizontally center children */
}

.file-upload {
  width: 20px;
  margin-top: 12px;
  margin-left: 20px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/component/screens/MessageInputSection.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA,EAAA,yBAAA;EACA,YAAA,EAAA,mCAAA;EACA,YAAA,EAAA,8BAAA;EACA,eAAA,EAAA,sBAAA;EACA,aAAA,EAAA,oBAAA;EACA,aAAA;AACF;;AAEA;EACE,SAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,kCAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA,EAAA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA,EAAA,iCAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AACF","sourcesContent":[".icon-mic {\n  width: 14px !important;\n  height: auto;\n  margin-right: 10px;\n  margin-left: 20px;\n}\n\n.textarea {\n  flex: 1; /* Take remaining space */\n  border: none; /* Remove default textarea border */\n  resize: none; /* Disable textarea resizing */\n  font-size: 14px; /* Example font size */\n  padding: 10px; /* Example padding */\n  outline: none;\n}\n\n.send-button {\n  width: 7%;\n  height: 30px;\n  margin: 7px 20px 0 15px;\n  cursor: pointer;\n  background-color: rgb(161, 0, 255);\n  border-radius: 20px;\n}\n\n.mid-section {\n  background-color: white;\n  height: 45px;\n  width: 50%;\n  border-radius: 18px;\n  border: 1px solid white;\n  margin: 20px auto 0; /* shorthand for margin: top auto 0; */\n  display: flex;\n  flex-direction: row;\n  justify-content: center; /* horizontally center children */\n}\n\n.file-upload {\n  width: 20px;\n  margin-top: 12px;\n  margin-left: 20px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
